import React, { FC } from 'react';
import { User } from 'api/models';
import { FieldValue } from 'api/notifications/meta';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { FieldChangedMessage, renderFieldValue } from './field-changed';

export const ProjectFieldChangedMessage: FC<{
  by: User;
  name: string;
  from?: FieldValue;
  to?: FieldValue;
}> = ({ by, name, from, to }) => (
  <FieldChangedMessage
    by={by}
    prefix={useTranslation('project').toLowerCase()}
    name={useTranslation(`fields.${name}` as TranslationKey)}
    from={renderFieldValue(from)}
    to={renderFieldValue(to)}
  />
);
